/**
 * CustomizeClientAppsCtrl controller
 */

CustomizeClientAppsCtrl.mixes = [
  ['m2mCtrlMixin', 'bannerCarousel', 'featureCarousel']
]

/**
 * CustomizeClientAppsCtrl controller
 *
 * @class CustomizeClientAppsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:CustomizeClientAppsCtrl
 */
/* @ngInject */
export default function CustomizeClientAppsCtrl ($scope, pckg, authSvc, inapp) {
  var vm = this

  /**
   * Default Package for in-app registration
   *
   * @memberof mwApp/packages.controller:AnnouncementsCtrl
   * @type {number}
   */
  vm.inappNetworkId = !inapp?.multiorgEnabled && inapp?.inAppRegistrationSettings?.enabled && inapp.inAppRegistrationSettings.network?.id

  /**
   * Default Package for Guest Mode
   *
   * @memberof mwApp/packages.controller:SubscriptionSettingsCtrl
   * @type {number}
   */
  vm.guestNetworkId = !inapp?.multiorgEnabled && inapp?.guestModeSettings?.enabled && inapp.guestModeSettings.network?.id

  vm.mixes = [['tabsCtrlMixin', '', 'moduleConfiguration', 'channelListing', 'general', 'settings']]
  vm.activeTab = 2

  vm.hasAccess = function (access) {
    return authSvc.hasAccess(access)
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Network
   *
   * @memberof mwApp/packages.controller:CustomizeClientAppCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  $scope.$on('$destroy', function () {
    window.localStorage.setItem('activeTab', vm.activeTab)
  })
}
